// Core packages
import { OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
// Third party packages
import { MatDialog, MatDialogRef } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { CondoStructuresService } from "src/app/modules/properties/condo-structures.service";
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { SettingsService } from "src/app/modules/settings/settings.service";
import { ConfigService } from "src/app/shared/services/config.service";
/**
 * Script start
 */
var PropertyDetailMappingViewDialogComponent = /** @class */ (function () {
    // END - Formly config
    /**
     * Class constructor
     */
    function PropertyDetailMappingViewDialogComponent(dialogRef, data, dialog, configService, translateService, authService, cookieService, propertiesService, condoStructuresService, toastrService, settingsService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.dialog = dialog;
        this.configService = configService;
        this.translateService = translateService;
        this.authService = authService;
        this.cookieService = cookieService;
        this.propertiesService = propertiesService;
        this.condoStructuresService = condoStructuresService;
        this.toastrService = toastrService;
        this.settingsService = settingsService;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        this.dialogIsLoading = false; // Used to view/hide form loading spinner
        this.noDocs = false;
        this.docs = [];
        this.propertyId = "";
        this.cardIsLoading = true;
        this.mappingIndex = [];
        this.condoStructureTemplateId = "";
        this.condoStructureTemplate = [];
        this.rimappatura = false;
        this.mappaturaOpen = false;
        this.onDestroy$ = new Subject();
        this.remakePlant = false;
        this.remakePlantDocs = {};
        // BEGIN - Formly config
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {
            formState: {
                disabled: false
            }
        };
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.save"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: true,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-save",
                inline: true
            }
        };
    }
    /**
     * Init components
     *
     * @since 1.0.0
     */
    PropertyDetailMappingViewDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.data && this.data.structureId) {
            this.condoStructuresService
                .getView(this.data.structureId)
                .subscribe(function (res) {
                if (res.status) {
                    _this.condoStructure = res.data;
                }
                else {
                    _this.toastrService.error(res.message);
                }
                _this.subscriptions.push(_this.propertiesService.getView(_this.condoStructure.property).subscribe(function (res) {
                    if (res.status) {
                        // Set permission data
                        _this.property = res.data;
                        _this.onChanges();
                        return;
                    }
                }, function (err) {
                    // if we came here users with given userId do not exist
                }));
                _this.cardIsLoading = false;
            });
        }
        else {
            this.cardIsLoading = false;
        }
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) { return (_this.loggedUser = res); }));
        this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(function (res) { return (_this.loggedUserPermissions = res); }));
        // Get current lang
        this.lang =
            this.cookieService.get("lang") || this.configService.defaultLang;
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    PropertyDetailMappingViewDialogComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Handle dialog close
     *
     * @since 1.0.0
     */
    PropertyDetailMappingViewDialogComponent.prototype.onClose = function () {
        this.dialogRef.close();
    };
    /**
     * Listen on input values changes
     *
     * @since 1.0.0
     */
    PropertyDetailMappingViewDialogComponent.prototype.onChanges = function () {
        var _this = this;
        // Update property
        if (this.property && this.property.currentValue && this.property.currentValue._id) {
            this.property = this.property.currentValue;
            this.propertyId = this.property.currentValue._id;
        }
        // Update form section depending on current mappingFormActiveSection
        if (this.property) {
            this.mappaturaOpen = this.condoStructure.open;
            if (this.condoStructure.rimappatura) {
                this.rimappatura = true;
            }
            if (this.mappingIndex.length === 0) {
                this.subscriptions.push(this.settingsService.getStructureView().subscribe(function (res) {
                    if (res.status) {
                        if (res.condoStructureTemplate &&
                            Array.isArray(res.condoStructureTemplate) &&
                            res.condoStructureTemplate.length > 0 &&
                            res.condoStructureTemplate[0].area &&
                            Array.isArray(res.condoStructureTemplate[0].area)) {
                            _this.condoStructureTemplateId = res.condoStructureTemplate[0]._id;
                            _this.condoStructureTemplate = res.condoStructureTemplate[0].area;
                            var structureTemplate = JSON.parse(JSON.stringify(_this.condoStructureTemplate));
                            // hide question deleted
                            _this.mappingIndex = structureTemplate.filter(function (el) {
                                if (!el.deleted) {
                                    if (el.content && Array.isArray(el.content)) {
                                        var content = el.content.filter(function (subEl) { return !subEl.deleted; });
                                        if (content && Array.isArray(content)) {
                                            content.forEach(function (subContent) {
                                                if (subContent &&
                                                    subContent.formConfig &&
                                                    Array.isArray(subContent.formConfig) &&
                                                    subContent.formConfig.length === 1 &&
                                                    subContent.formConfig[0].fieldGroup &&
                                                    Array.isArray(subContent.formConfig[0].fieldGroup)) {
                                                    var fieldGroup = subContent.formConfig[0].fieldGroup.filter(function (group) { return !group.deleted; });
                                                    subContent.formConfig[0].fieldGroup = fieldGroup;
                                                }
                                            });
                                        }
                                        el.content = content;
                                    }
                                    return true;
                                }
                            });
                            _this.mappingIndex = _this.translateKeys2(["placeholder", "label"], _this.mappingIndex);
                            _this.updateFormSection();
                            _this.cardIsLoading = false;
                            if (_this.property.type === "bsc") {
                                var strutture = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.strutture";
                                });
                                if (strutture
                                    && strutture.content
                                    && Array.isArray(strutture.content)) {
                                    var index = strutture.content.findIndex(function (item) {
                                        return item.key === "condominiBsc";
                                    });
                                    strutture.content[index].hidden = false;
                                    index = strutture.content.findIndex(function (item) {
                                        return item.key === "fabbricatoAbitativo";
                                    });
                                    strutture.content[index].hidden = true;
                                    index = strutture.content.findIndex(function (item) {
                                        return item.key === "struttureFabbindip";
                                    });
                                    strutture.content[index].hidden = false;
                                }
                                var trattamentoAcqua = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.trattamentoAcqua";
                                });
                                if (trattamentoAcqua
                                    && trattamentoAcqua.content
                                    && Array.isArray(trattamentoAcqua.content)) {
                                    var index = trattamentoAcqua.content.findIndex(function (item) {
                                        return item.key === "sottostazioneAltroCondBsc";
                                    });
                                    trattamentoAcqua.content[index].hidden = true;
                                }
                                var riscaldamentoCondizionamento = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.riscaldamentoCondizionamento";
                                });
                                if (riscaldamentoCondizionamento
                                    && riscaldamentoCondizionamento.content
                                    && Array.isArray(riscaldamentoCondizionamento.content)) {
                                    // let index = riscaldamentoCondizionamento.content.findIndex((item: any) => {
                                    //   return item.key === "sottostazioniCt"
                                    // });
                                    // riscaldamentoCondizionamento.content[index].hidden = true;
                                    // let index = riscaldamentoCondizionamento.content.findIndex((item: any) => {
                                    //   return item.key === "centraleRicervimento"
                                    // });
                                    // riscaldamentoCondizionamento.content[index].hidden = true;
                                    var index = riscaldamentoCondizionamento.content.findIndex(function (item) {
                                        return item.key === "cannaCollettiva";
                                    });
                                    riscaldamentoCondizionamento.content[index].hidden = true;
                                }
                                var dispositiviAntincendio = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.dispositiviAntincendio";
                                });
                                if (dispositiviAntincendio
                                    && dispositiviAntincendio.content
                                    && Array.isArray(dispositiviAntincendio.content)) {
                                    var index = dispositiviAntincendio.content.findIndex(function (item) {
                                        return item.key === "evac";
                                    });
                                    dispositiviAntincendio.content[index].hidden = true;
                                }
                            }
                            else {
                                var strutture = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.strutture";
                                });
                                if (strutture
                                    && strutture.content
                                    && Array.isArray(strutture.content)) {
                                    var index = strutture.content.findIndex(function (item) {
                                        return item.key === "condominiBsc";
                                    });
                                    strutture.content[index].hidden = true;
                                    index = strutture.content.findIndex(function (item) {
                                        return item.key === "fabbricatoAbitativo";
                                    });
                                    strutture.content[index].hidden = false;
                                    index = strutture.content.findIndex(function (item) {
                                        return item.key === "struttureFabbindip";
                                    });
                                    strutture.content[index].hidden = false;
                                }
                                var trattamentoAcqua = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.trattamentoAcqua";
                                });
                                if (trattamentoAcqua
                                    && trattamentoAcqua.content
                                    && Array.isArray(trattamentoAcqua.content)) {
                                    var index = trattamentoAcqua.content.findIndex(function (item) {
                                        return item.key === "sottostazioneAltroCondBsc";
                                    });
                                    trattamentoAcqua.content[index].hidden = false;
                                }
                                var riscaldamentoCondizionamento = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.riscaldamentoCondizionamento";
                                });
                                if (riscaldamentoCondizionamento
                                    && riscaldamentoCondizionamento.content
                                    && Array.isArray(riscaldamentoCondizionamento.content)) {
                                    // let index = riscaldamentoCondizionamento.content.findIndex((item: any) => {
                                    //   return item.key === "sottostazioniCt"
                                    // });
                                    // riscaldamentoCondizionamento.content[index].hidden = false;
                                    // let index = riscaldamentoCondizionamento.content.findIndex((item: any) => {
                                    //   return item.key === "centraleRicervimento"
                                    // });
                                    // riscaldamentoCondizionamento.content[index].hidden = false;
                                    var index = riscaldamentoCondizionamento.content.findIndex(function (item) {
                                        return item.key === "cannaCollettiva";
                                    });
                                    riscaldamentoCondizionamento.content[index].hidden = false;
                                }
                                var dispositiviAntincendio = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.dispositiviAntincendio";
                                });
                                if (dispositiviAntincendio
                                    && dispositiviAntincendio.content
                                    && Array.isArray(dispositiviAntincendio.content)) {
                                    var index = dispositiviAntincendio.content.findIndex(function (item) {
                                        return item.key === "evac";
                                    });
                                    dispositiviAntincendio.content[index].hidden = false;
                                }
                            }
                            // Enable fields if we're adding a new element, else disable form
                            if (_this.form && _this.activeItem
                                && (!_this.formActiveSubitemId || _this.activeItem.key === "anagrafica")
                                && _this.mappaturaOpen) {
                                _this.options.formState = {
                                    disabled: false
                                };
                                _this.formBtnOptions.disabled = false;
                                // Check new element and remake plant, then
                                // get save docs to import in new plant
                                if (_this.formActiveSection && !_this.formActiveSubitemId) {
                                    _this.remakePlantDocs = _this.condoStructuresService.getRemakeStrucutureDocs();
                                    // Check if same plant then remake plant.
                                    if (_this.remakePlantDocs
                                        && _this.remakePlantDocs.activeSection &&
                                        _this.remakePlantDocs.activeSection === _this.formActiveSection) {
                                        _this.remakePlant = true;
                                    }
                                    else {
                                        _this.remakePlant = false;
                                        _this.condoStructuresService.setRemakeStrucutureDocs("", "", {});
                                    }
                                }
                                if (typeof _this.model.files === "undefined") {
                                    _this.model["files"] = [];
                                }
                            }
                            else if (_this.form && _this.formActiveSubitemId) {
                                _this.options.formState = {
                                    disabled: true
                                };
                                _this.formBtnOptions.disabled = true;
                            }
                        }
                    }
                }));
            }
            else {
                this.updateFormSection();
                this.cardIsLoading = false;
            }
            // @OLD
            // this.updateFormSection();
        }
    };
    /**
     * Translate all keys with given labels inside given object and returns it
     *
     * @since 4.0.0
     */
    PropertyDetailMappingViewDialogComponent.prototype.translateKeys2 = function (keys, obj) {
        var _this = this;
        if (Array.isArray(obj)) {
            obj.forEach(function (item) {
                var _loop_1 = function (prop) {
                    // hooks: 
                    // 1) numerazione progressiva all'aggiunta delle scale del Fabbricato abitativo
                    // 2) numerazione progressiva all'aggiunta dei bruciatori di Centrale termica
                    if (prop === "hooks") {
                        var propKey_1 = item[prop];
                        item[prop] = {
                            onInit: function (field) {
                                field.defaultValue = propKey_1 + " " + (+field.parent.key + 1);
                            },
                        };
                    }
                    // hideExpression: 
                    // nasconde il corrente campo se il valore del campo indicato soddisfa i criteri indicati da "operator"
                    // e diabilita l'obbligatorietà del campo in "templateOptions.required"
                    if (prop === "hideExpression" && item[prop]) {
                        var propKey_2 = item[prop].key;
                        var propCompareValue_1 = item[prop].value;
                        if (item[prop].operator === "!==") {
                            item[prop] = function (model, formState, field) {
                                var key = propKey_2;
                                var currentValue = model[key];
                                var compareValue = propCompareValue_1;
                                return currentValue !== compareValue;
                            };
                        }
                        else if (item[prop].operator === "!") {
                            item[prop] = function (model, formState, field) {
                                var key = propKey_2;
                                var currentValue = model[key];
                                return !currentValue;
                            };
                        }
                        else if (item[prop].operator === "!includes") {
                            item[prop] = function (model, formState, field) {
                                var key = propKey_2;
                                var currentValue = model[key];
                                var compareValue = propCompareValue_1;
                                return typeof currentValue === "undefined" || !currentValue.includes(compareValue);
                            };
                        }
                    }
                    // expressionProperties:
                    // Contatore energia elettrica:
                    // disabilita il campo "connessioni" e/o "alimenta un singolo impianto" 
                    // usato in "templateOptions.disabled"
                    if (prop === "expressionProperties" && item[prop]) {
                        var propDisabled = item[prop].disabled;
                        if (propDisabled !== "formState.disabled" &&
                            propDisabled !== "connessioni" &&
                            propDisabled !== "") {
                            var key_1 = propDisabled;
                            propDisabled = function (model, formState, field) {
                                return model[key_1] || formState.disabled;
                            };
                        }
                        else if (propDisabled === "connessioni") {
                            var key_2 = propDisabled;
                            propDisabled = function (model, formState, field) {
                                if (model[key_2] === "undefined") {
                                    return false;
                                }
                                else if (Array.isArray(model[key_2]) && model[key_2].length > 0) {
                                    return true;
                                }
                                return false;
                            };
                        }
                        if (typeof item[prop].required !== "undefined") {
                            var propKey_3 = item[prop].required.key;
                            var propCompareValue_2 = item[prop].required.value;
                            if (item[prop].required.operator === "===") {
                                item[prop] = {
                                    "templateOptions.disabled": propDisabled,
                                    "templateOptions.required": function (model, formState, field) {
                                        var key = propKey_3;
                                        var currentValue = model[key];
                                        var compareValue = propCompareValue_2;
                                        return currentValue === compareValue;
                                    }
                                };
                            }
                            else if (item[prop].required.operator === "!") {
                                item[prop] = {
                                    "templateOptions.disabled": propDisabled,
                                    "templateOptions.required": function (model, formState, field) {
                                        var key = propKey_3;
                                        var currentValue = model[key];
                                        return !currentValue;
                                    }
                                };
                            }
                            else if (item[prop].required.operator === "") {
                                item[prop] = {
                                    "templateOptions.disabled": propDisabled,
                                    "templateOptions.required": function (model, formState, field) {
                                        var key = propKey_3;
                                        var currentValue = model[key];
                                        return currentValue;
                                    }
                                };
                            }
                        }
                        else {
                            item[prop] = {
                                "templateOptions.disabled": propDisabled,
                            };
                        }
                    }
                    // defaultValue:
                    // contiene il valore predefinito del campo corrente
                    if (prop === "defaultValue" && item[prop]) {
                        if (item[prop] === "false") {
                            item[prop] = false;
                        }
                        else if (item[prop] === "true") {
                            item[prop] = true;
                        }
                    }
                    // wrappers:
                    // struttura del titolo/campo nel form: orizzontale/verticale  
                    // oppure in assenza di "key" e in presenza di "template" => visualizza contenuto di "template"
                    if (prop === "wrappers" && item[prop] && Array.isArray(item[prop]) && item[prop].length === 0) {
                        item[prop] = "";
                    }
                    if (item.hasOwnProperty(prop)) {
                        if (keys.includes(prop)) {
                            if (item["translation"]) {
                                item[prop] = item["translation"].it;
                            }
                        }
                        if (typeof item[prop] === "object") {
                            item[prop] = _this.translateKeys2(keys, item[prop]);
                        }
                    }
                };
                for (var prop in item) {
                    _loop_1(prop);
                }
            });
        }
        else {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    // options:
                    // in "templateOptions" e
                    // contiene l'elenco dei valori del campo di tipo select (value/translation)
                    if (prop === "options" && Array.isArray(obj[prop])) {
                        obj[prop].forEach(function (elem) {
                            if (elem.value && elem.value === "true") {
                                elem.value = true;
                            }
                            else if (elem.value && elem.value === "false") {
                                elem.value = false;
                            }
                        });
                    }
                    if (keys.includes(prop) && obj[prop]) {
                        obj[prop] = this.translateService.instant(obj[prop]);
                        if (prop === "label" && obj["translationLabel"]) {
                            obj[prop] = obj["translationLabel"].it;
                        }
                        else if (prop === "placeholder" && obj["translationPlaceholder"]) {
                            obj[prop] = obj["translationPlaceholder"].it;
                        }
                    }
                    if (typeof obj[prop] === "object") {
                        obj[prop] = this.translateKeys2(keys, obj[prop]);
                    }
                }
            }
        }
        return obj;
    };
    /**
     * Get children (existing values) for requested section
     *
     * @since 1.0.0
     */
    PropertyDetailMappingViewDialogComponent.prototype.getChildren = function (key) {
        if (typeof this.condoStructure !== "undefined"
            && typeof this.condoStructure[key] !== "undefined") {
            if (key === "anagrafica") {
                return [];
            }
            else {
                if (Array.isArray(this.condoStructure[key])) {
                    var structures = JSON.parse(JSON.stringify(this.condoStructure[key]));
                    structures = structures.filter(function (el) { return el.active; });
                    return structures;
                }
                else {
                    return [];
                }
            }
        }
        return [];
    };
    /**
     * Update form section depending on route params
     *
     * @since 1.0.0
     */
    PropertyDetailMappingViewDialogComponent.prototype.updateFormSection = function () {
        // Reset model to prevent import previous form data
        if (this.model) {
            for (var property in this.model) {
                delete this.model[property];
            }
        }
        var target = document.getElementById("sideMenu");
        var top = target.offsetHeight;
        window.scrollTo({
            top: top,
            behavior: "smooth",
        });
        // Reset data and call the new data form
        if (this.form) {
            this.options.formState = {
                disabled: true
            };
        }
        // Add section param to routing, which is used in connections type
        // const params = Object.assign({}, this.activatedRoute.snapshot.params, { selected: false });
        // params.mappingFormActiveSection = this.formActiveSection;
        // this.activatedRoute.snapshot.params = params;
        // if (this.formActiveSection) {
        //   this.formIsLoading = true; // Start form loading
        //   // BEGIN - Set open status to current mapping index
        //   const origFormActiveSection = this.formActiveSection.replace(
        //     this.property.structure,
        //     ":structureId"
        //   );
        //   this.mappingIndex.map((item: MappingIndex) => {
        //     item.content.map((subItem: MappingIndex) => {
        //       if (subItem.section === origFormActiveSection) {
        //         // Get currente element is a Plant
        //         // delete note field from form
        //         // if (subItem.formConfig
        //         //   && Array.isArray(subItem.formConfig)
        //         //   && subItem.formConfig.length) {
        //         //   if (subItem.formConfig[0].fieldGroup
        //         //     && Array.isArray(subItem.formConfig[0].fieldGroup)
        //         //     && subItem.formConfig[0].fieldGroup.length) {
        //         //     const index = subItem.formConfig[0].fieldGroup.findIndex((el: any) => {
        //         //       return el.key === "note";
        //         //     })
        //         //     if (index > -1) {
        //         //       subItem.formConfig[0].fieldGroup.splice(index, 1);
        //         //     }
        //         //   }
        //         // }
        //         if (
        //           item.title === "properties.structures.impiantiElettrici" ||
        //           item.title === "properties.structures.trattamentoAcqua" ||
        //           item.title ===
        //           "properties.structures.riscaldamentoCondizionamento" ||
        //           item.title === "properties.structures.dispositiviAntincendio" ||
        //           item.title === "properties.structures.ascensoriEMontauto" ||
        //           item.title === "properties.structures.impiantiElettronici" ||
        //           item.title === "properties.structures.lineeVita" ||
        //           item.title === "properties.structures.impiantiSpeciali" ||
        //           item.title === "properties.structures.impiantiRicreativi"
        //         ) {
        //           this.sectionPlant = true;
        //         } else {
        //           this.sectionPlant = false;
        //         }
        //         item.expanded = true;
        //         subItem.expanded = true;
        //         subItem.active = true;
        //         this.activeItem = subItem;
        //         if (
        //           this.formActiveSection &&
        //           origFormActiveSection !==
        //           "condo-structures/:structureId/anagrafica"
        //         ) {
        //           const children = this.getChildren(subItem.key);
        //           if (children.length) {
        //             this.activeSubitem = children.find(
        //               (val: any) => val._id === this.formActiveSubitemId
        //             );
        //             if (this.activeSubitem && this.activeSubitem.files) {
        //               if (this.form.controls.files) {
        //                 this.form.controls.files.setValue(this.activeSubitem.files);
        //               }
        //               this.form.updateValueAndValidity();
        //             }
        //             if (this.activeSubitem && this.activeSubitem.note) {
        //               this.existingNotes = this.activeSubitem.note;
        //               this.activeSubitem.note = null;
        //             }
        //             this.fields = subItem.formConfig;
        //             if (this.activeSubitem) {
        //               this.model = this.activeSubitem;
        //             } else {
        //               // Add new subitem. Default name from section
        //               const tot = children.length + 1;
        //               const nome = `${subItem.translation.it} ${tot}`;
        //                 // this.translateService.instant(subItem.title) + " " + tot;
        //               this.model = { nome, files: [], };
        //               // Delete defaultValue from field Files, to clear previous upload image
        //               if (subItem.formConfig
        //                 && Array.isArray(subItem.formConfig)
        //                 && subItem.formConfig.length) {
        //                 if (subItem.formConfig[0].fieldGroup
        //                   && Array.isArray(subItem.formConfig[0].fieldGroup)
        //                   && subItem.formConfig[0].fieldGroup.length) {
        //                   const index = subItem.formConfig[0].fieldGroup.findIndex((el: any) => {
        //                     return el.key === "files";
        //                   })
        //                   if (index > -1) {
        //                     if (subItem.formConfig[0].fieldGroup[index].templateOptions
        //                       && Array.isArray(subItem.formConfig[0].fieldGroup[index].templateOptions.defaultValue)
        //                       && subItem.formConfig[0].fieldGroup[index].templateOptions.defaultValue.length) {
        //                       subItem.formConfig[0].fieldGroup[index].templateOptions.defaultValue = [];
        //                     }
        //                   }
        //                 }
        //               }
        //             }
        //           } else {
        //             if (this.activeSubitem && this.activeSubitem.note) {
        //               this.existingNotes = this.activeSubitem.note;
        //               this.activeSubitem.note = null;
        //             }
        //             // New first subitem. Default name from section
        //             this.fields = subItem.formConfig;
        //             const nome = `${subItem.translation.it} 1`;
        //               // this.translateService.instant(subItem.title) + " 1";
        //             this.model = { nome, files: [], };
        //             // Delete defaultValue from field Files, to clear previous upload image
        //             if (subItem.formConfig
        //               && Array.isArray(subItem.formConfig)
        //               && subItem.formConfig.length) {
        //               if (subItem.formConfig[0].fieldGroup
        //                 && Array.isArray(subItem.formConfig[0].fieldGroup)
        //                 && subItem.formConfig[0].fieldGroup.length) {
        //                 const index = subItem.formConfig[0].fieldGroup.findIndex((el: any) => {
        //                   return el.key === "files";
        //                 })
        //                 if (index > -1) {
        //                   if (subItem.formConfig[0].fieldGroup[index].templateOptions
        //                     && Array.isArray(subItem.formConfig[0].fieldGroup[index].templateOptions.defaultValue)
        //                     && subItem.formConfig[0].fieldGroup[index].templateOptions.defaultValue.length) {
        //                     subItem.formConfig[0].fieldGroup[index].templateOptions.defaultValue = [];
        //                   }
        //                 }
        //               }
        //             }
        //           }
        //         } else if (
        //           subItem.section === "condo-structures/:structureId/anagrafica"
        //         ) {
        //           this.activeSubitem = this.condoStructure.anagrafica;
        //           // Anagrafica: is not completed
        //           if (typeof this.activeSubitem === "undefined") {
        //             this.activeSubitem = {
        //               active: true
        //             };
        //           }
        //           if (this.activeSubitem && this.activeSubitem.note) {
        //             this.existingNotes = this.activeSubitem.note;
        //             this.activeSubitem.note = null;
        //           }
        //           this.fields = subItem.formConfig;
        //           this.model = this.activeSubitem;
        //           this.formActiveSubitemId = Math.random().toString();
        //         }
        //       } else {
        //         subItem.active = false;
        //       }
        //     });
        //   });
        //   if (this.form && !this.condoStructure.open) {
        //     this.options.formState = {
        //       disabled: true
        //     };
        //   }
        //   // END - Set open status to current mapping index
        //   setTimeout(() => {
        //     this.formIsLoading = false;
        //   }, 300);
        // } else {
        // Reset the last item.expanded mappingIndex to close tree from previous structure
        if (Array.isArray(this.mappingIndex) && this.mappingIndex.length) {
            this.mappingIndex.forEach(function (item) {
                if (item.expanded) {
                    item.expanded = false;
                    if (Array.isArray(item.content) && item.content.length) {
                        item.content.forEach(function (elem) {
                            if (elem.active) {
                                elem.active = false;
                            }
                        });
                    }
                }
            });
        }
        // }
    };
    /**
     * Check if given macr-section item is visibile or not depending on
     * structure open status. If structure is open, than this will always returns true
     * If it's false, this will check if at least one sub-section has one or more
     * values. If so, return true, otherwise return false;
     *
     * @since 1.0.0
     */
    PropertyDetailMappingViewDialogComponent.prototype.checkVisibility = function (item) {
        var _this = this;
        // if (!this.mappaturaOpen) {
        if (item.content && item.content.length) {
            // Let's make anagrafica section ALWAYS visible
            if (item.content[0].key === "anagrafica") {
                return true;
            }
            return item.content.some(function (subitem) { return _this.getChildren(subitem.key).length; });
        }
        return false;
        // }
        // return true;
    };
    /**
     * Prints the whole HTML contained in "dataToPrint" element
     *
     * @since 1.0.0
     */
    PropertyDetailMappingViewDialogComponent.prototype.onPrint = function () {
        var title = this.translateService.instant("properties.detail.mappingTab.viewMapping");
        title = title.replace(" ", "-");
        var printData = document.getElementById('dataToPrint').innerHTML;
        var openWindow = window.open("", title, "");
        openWindow.document.write('<style type="text/css">');
        openWindow.document.write('  @media print {');
        openWindow.document.write('    .mat-badge {');
        openWindow.document.write('      display: none !important;');
        openWindow.document.write('    }');
        openWindow.document.write('    .amiantoIcon {');
        openWindow.document.write('      display: none !important;');
        openWindow.document.write('    }');
        openWindow.document.write('  }');
        openWindow.document.write('</style>');
        openWindow.document.write(printData);
        openWindow.document.close();
        openWindow.focus();
        openWindow.print();
        openWindow.close();
    };
    return PropertyDetailMappingViewDialogComponent;
}());
export { PropertyDetailMappingViewDialogComponent };
